<template>
  <div class="bwp-wrapper">
    <div class="or-helper or-helper--hidden flex flex-row items-center mt-2">
      <hr class="grow" />
      <span class="px-4">or</span>
      <hr class="grow" />
    </div>
    <div
      v-once
      id="amzn-buy-now"
      :data-site-id="buyWithPrimeSiteId"
      :data-widget-id="buyWithPrimeWidgetId"
      :data-sku="sku"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'BuyWithPrime',

  props: {
    sku: {
      default: null,
      type: String
    }
  },

  data() {
    return {
      buyWithPrimeSiteId: process.env.buyWithPrimeSiteId,
      buyWithPrimeWidgetId: process.env.buyWithPrimeWidgetId,
      buyWithPrimeTarget: null,
      buyWithPrimeObserver: null
    }
  },

  mounted() {
    this.setupObserver()
    this.setupBuyWithPrimeButton()
  },

  beforeDestroy() {
    try {
      if (window.bwp) {
        window.bwp.disableWidget()
      }
    } catch (error) {
      if (error.message === 'bwp widget has not been created yet') {
        // TD - Ignore this error as it's expected for products
        // that don't have the BWP button displayed.
      } else {
        // Re-throw the error if it's something else.
        throw error
      }
    }

    window.bwp = undefined
    window.bwpCartScriptLoadedOn = undefined

    this.buyWithPrimeObserver && this.buyWithPrimeObserver.disconnect()
  },

  methods: {
    setupBuyWithPrimeButton() {
      window.bwp = undefined
      window.bwpCartScriptLoadedOn = undefined

      const bwpScript = document.createElement('script')

      bwpScript.setAttribute('async', true)
      bwpScript.setAttribute('fetchpriority', 'high')
      bwpScript.setAttribute(
        'src',
        'https://code.buywithprime.amazon.com/bwp.v1.js'
      )

      this.$el.appendChild(bwpScript)
    },
    setupObserver() {
      this.buyWithPrimeTarget = this.$el

      if (this.buyWithPrimeTarget) {
        this.buyWithPrimeObserver = new MutationObserver(
          (mutationList, observer) => {
            mutationList.forEach(mutation => {
              if (
                mutation.target.nodeName === 'IFRAME' &&
                mutation.target.clientHeight > 0
              ) {
                this.buyWithPrimeTarget
                  .querySelector('.or-helper')
                  .classList.remove('or-helper--hidden')
              }
            })
          }
        )

        this.buyWithPrimeObserver.observe(this.buyWithPrimeTarget, {
          subtree: true,
          childList: true,
          attributes: true
        })
      } else {
        setTimeout(this.setupObserver, 100)
      }
    }
  }
}
</script>

<style>
.or-helper--hidden {
  display: none;
}

.or-helper > hr {
  background-color: var(--text-color);
  height: 1px;
}
</style>
